import type { NextRouter } from 'next/router'
import { PaymentMethod } from '../../schema/payment'

export enum Action {
  clickBackToDashboard = 'click-back-to-dashboard',
  clickCancel = 'click-cancel',
  clickChangeProductSelection = 'click-change-product-selection',
  clickDownload = 'click-download',
  clickFilterBranch = 'click-filter-branch',
  clickFilterByCategory = 'click-filter-by-category',
  clickFilterEducation = 'click-filter-education',
  clickFilterExperience = 'click-filter-experience',
  clickFilterSalary = 'click-filter-salary',
  clickJobDetails = 'click-job-details',
  clickJobMetrics = 'click-job-metrics',
  clickJobPreview = 'click-job-preview',
  clickJobUpgradeResults = 'click-job-upgrade-results',
  clickJobUpgradeShop = 'click-job-upgrade-shop',
  clickJobOverviewView = 'click-joboverview-view',
  clickNext = 'click-next',
  clickPerformanceView = 'click-performance-view',
  clickProceedToPayment = 'click-proceed-to-payment',
  searchJobByTitleOrId = 'search-job-by-title-or-id',
  searchJobApplicantByName = 'search-job-applicant-by-name',
  webshopCheckoutChangeProduct = 'webshop-checkout-change-product',
  jpfPlaceVacancy = 'jpf-place-vacancy',
  jpfCancelJobPosting = 'jpf-cancel-jobposting',
  jpfCloseJobPosting = 'jpf-click-close-button',
  jpfCheckoutChangeProduct = 'jpf-checkout-change-product',
  jpfFurtherJobPosting = 'jpf-further-jobposting',
  clickOnAccount = 'ClickOnAccount',
  clickDashboard = 'click-dashboard',
  clickProductEntitlements = 'click-product-entitlements',
  clickJobs = 'click-jobs',
  clickProfiles = 'click-profiles',
  clickWebshop = 'click-webshop',
  clickCart = 'click-cart',
  clickStatistics = 'click-statistics',
  addToCart = 'add-to-cart',
  addToCartModalClickToRegister = 'add-to-cart modal-click-to-register',
  addToCartModalClickToLogin = 'add-to-cart modal-click-to-login',
  saveContactDetails = 'contact-details-save',
  saveAccountSettings = 'account-settings-save',
  clickCheckboxPhoneConsent = 'checkbox-phone-contact-consent',
  clickCheckboxEmailConsent = 'checkbox-email-contact-consent',
  clickCheckboxJobExpiryConsent = 'checkbox-job-expiry-consent',
  webshopCheckoutToPayment = 'webshop-checkout-to-payment',
  jpfCheckoutToPayment = 'jpf-checkout-to-payment',
  websopPlaceOrder = 'webshop-place-order',
  jpfPlaceOrder = 'jpf-place-order',
}

export enum Category {
  b2bPortalJobOverView = 'b2b-portal-job-overview',
  b2bPortalJobPostingCart = 'b2b-portal-job-posting-cart',
  jobPostingFlow = 'jobposting-flow',
  b2bPortalJobReporting = 'b2b-portal-job-reporting',
  b2bPortalJobApplies = 'b2b-portal-job-applies',
  ecommerce = 'ecommerce',
  myJobDashboard = 'my-job-dashboard',
  navigationMenuLeftbar = 'navigation-menu-leftbar',
  header = 'header',
  accountDetails = 'account-details',
  accountSettings = 'account-settings',
  vacatures = 'vacatures'
}

export type Props = {
  router?: NextRouter,
  action?: Action,
  category?: Category,
  label?: string,
}

type GoogleAnalyticsAttrs = {
  'data-analytics-action': Action,
  'data-analytics-category': Category,
  'data-analytics-label': string,
}

export default (props: Props): GoogleAnalyticsAttrs | undefined => {
  const { action, category, label, router } = props || {}
  const analyticsLabel = label || (router && `${router.basePath}${router.asPath}`)

  if (action && category) {
    return {
      'data-analytics-action': action,
      'data-analytics-category': category,
      'data-analytics-label': analyticsLabel,
    }
  }
  return undefined
}

export const placeOrderEventLabelMap: Record<PaymentMethod, string> = {
  directdebit: 'offline-dd',
  invoice: 'offline-invoice',
  creditcard: 'online-cc',
  ideal: 'online-iDEAL',
  mastercard: 'online-mastercard',
  visa: 'online-visa'
}
